import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { Section, MiniStat, EmptyState, chartTooltip } from "./Section";
import { DEFINITIONS, GROUP_META, fmtMins, fmtHours } from "./definitions";

const pair = (s, fmt) => `${fmt(s.avg)} avg · ${fmt(s.median)} median`;

export const SpeedSection = ({ speed }) => {
  const ttr = ["ai_resolved", "ai_assisted", "human_only"].map((g) => ({
    name: GROUP_META[g].label, avg: speed.ttr_h[g].avg, median: speed.ttr_h[g].median, count: speed.ttr_h[g].count,
  }));
  const hasTtr = ttr.some((r) => r.count > 0);
  return (
    <Section title="Speed" testId="speed-section" info={[DEFINITIONS.frt, DEFINITIONS.ttc]}
      subtitle="First response, resolution and hand-off timings">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
        <MiniStat label="AI first response" value={fmtMins(speed.ai_frt_min.median)} hint={`median · ${fmtMins(speed.ai_frt_min.avg)} avg`} testId="stat-ai-frt" />
        <MiniStat label="Human baseline first response" value={fmtMins(speed.human_baseline_frt_min.median)}
          hint={`median · this period ${fmtMins(speed.human_frt_min.median)}`} testId="stat-human-frt" />
        <MiniStat label="First contact → handoff" value={fmtMins(speed.handoff_min.median)} hint={`median · ${speed.handoff_min.count} escalated`} testId="stat-handoff-time" />
        <MiniStat label="Human pick-up after handoff" value={fmtMins(speed.human_after_handoff_min.median)}
          hint={`median · ${fmtMins(speed.human_after_handoff_min.avg)} avg`} testId="stat-human-after-handoff" />
      </div>
      <p className="text-sm font-medium text-slate-700 mb-2">Time to resolution (hours)</p>
      {!hasTtr ? <EmptyState message="No closed conversations in this period." testId="ttr-empty" /> : (
        <>
          <div className="h-[200px]" data-testid="ttr-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={ttr}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip contentStyle={chartTooltip} formatter={(v) => fmtHours(v)} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Bar dataKey="avg" name="Average" fill="#425B76" radius={[4, 4, 0, 0]} />
                <Bar dataKey="median" name="Median" fill="#F5C518" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="grid grid-cols-3 gap-2 mt-2 text-[11px] text-slate-500">
            {ttr.map((r) => <span key={r.name} data-testid={`ttr-${r.name}`}>{r.name}: {pair({ avg: r.avg, median: r.median }, fmtHours)} ({r.count})</span>)}
          </div>
        </>
      )}
    </Section>
  );
};
